import YoutubeEmbed from './YoutubeEmbed'

export default YoutubeEmbed
